<template>
  <main class="container">
    <div class="newcomer-guide">
      <span class="card-tip">可用免单卡：{{getTabBarZeroBadge.TotalFreeCardNum}} 张</span>
      <h3 class="guide-title">新人前{{ getNewPersonFreeOrderCount }}单福利</h3>
      <p class="guide-tip">全场1张免单卡兑换</p>
      <div class="guide-list">
        <div class="guide-item">
          <i class="iconfont icon-gouwuche1"></i>
          <span>挑选商品</span>
        </div>
        <div class="guide-item-icon"><i class="iconfont icon-jiantou2"></i></div>
        <div class="guide-item">
          <i class="iconfont icon-yiwancheng"></i>
          <span>下单购买</span>
        </div>
        <div class="guide-item-icon"><i class="iconfont icon-jiantou2"></i></div>
        <div class="guide-item">
          <i class="iconfont icon-jiage"></i>
          <span>领取返利</span>
        </div>
      </div>
    </div>
    <div class="newcomer-box-list">
      <!-- 这里和不是新手的0元购有所不同 -->
      <time-scrroll
        ref="timeScroll"
        type="warn"
        :time-list="timeList"
        :time-index="currentTimeIndex"
        @timeScrollClick="timeScrollClick">
      </time-scrroll>
      <!-- 筛选 -->
      <filter-radio
        class="filterRadioRef"
        ref="filterRadioRef"
        :is-fixed="isFixed"
        :is-current-time="isCurrentTime"
        @filterChange="filterChange"
        @platformChange="platformChange">
      </filter-radio>
      <!-- 内容 -->
      <div class="zero-list-cnt">
        <template v-if="isCurrentTime === true">
          <!-- <template v-if="dataList.length > 0"> -->
            <souhuo-list
              :data-list="dataList"
              :is-fake-data="isFakeSkeleton"
              :is-newcomer="isNewcomer"
              :show-head="false"
              :scroll-disabled="scrollDisabled"
              @loadMore="loadMore"
              @entoDetailPage="convertShop">
            </souhuo-list>
            <segement-Line v-if="!haveMore" line-text="没有更多商品啦"></segement-Line>
            <segement-Line v-else :is-load="true" line-text="正在加载"></segement-Line>
          <!-- </template> -->
          <segement-line v-if="dataList.length <= 0" line-text="暂无相关商品"></segement-line>
        </template>
        <!-- 热销商品模块 → 上个版本为【限时抢购】模块 -->
        <template v-else-if="isCurrentTime === 'flashSale'">
          <template v-if="flashSaleListDataList.length > 0">
            <flash-sale-list
              :data-list="flashSaleListDataList"
              :scroll-disabled="scrollDisabled"
              :is-newcomer="isNewcomer"
              @loadMore="loadMore">
            </flash-sale-list>
            <segement-Line v-if="!haveMore" line-text="没有更多商品啦"></segement-Line>
            <segement-Line v-else :is-load="true" line-text="正在加载"></segement-Line>
          </template>
          <segement-line v-else line-text="暂无热销商品"></segement-line>
        </template>
        <!-- 不是当前节点(未来节点)横向显示列表 -->
        <template v-else>
          <template v-if="dataList.length > 0">
            <row-list
              :data-list="dataList"
              :scroll-disabled="scrollDisabled"
              :is-newcomer="isNewcomer"
              @loadMore="loadMore"
              @remindMe="remindMe"
              @cancelRemind="cancelRemind">
            </row-list>
            <segement-Line v-if="!haveMore" line-text="没有更多商品啦"></segement-Line>
            <segement-Line v-else :is-load="true" line-text="正在加载"></segement-Line>
          </template>
          <!-- 无商品 -->
          <div class="no-more-goods" v-if="!scrollDisabled && dataList.length <= 0">
            <div class="no-more-img">
              <img src="@/assets/image/superman.png" alt="暂无商品">
            </div>
            <p>商品正在努力准备中...</p>
            <p>先去逛逛鸭~</p>
          </div>
        </template>
      </div>
      <!-- 返回顶部 -->
      <quick-top @returnTop="returnTop" :isReturn="isReturn" :positionBtm="80"></quick-top>
    </div>
  </main>
</template>

<script>
import { mapGetters } from 'vuex'
import zeroBuyMixins from '@/views/zeroBuy/zeroBuyMain/mixins/zeroBuyMixins'

export default {
  name: 'NewcomerPage',
  mixins: [zeroBuyMixins],
  data () {
    return {
      isNewcomerPage: true // 是否是新人页面，用于后端限制查询
    }
  },
  computed: {
    ...mapGetters(['getNewPersonFreeOrderCount'])
  }
}
</script>

<style scoped>
  .newcomer-guide{
    position: relative;
    height: 53vw;
    padding: 2vw;
    box-sizing: border-box;
    background: #f35652;
    background: url('http://youp-read.leqilucky.com/upaiyun/Sys/20200708/5331229908428409150.jpeg') no-repeat;
    background-size: 100% auto;
    background-position: center center;
    overflow: hidden;
    text-align: center;
  }
  .filterRadioRef {
    margin-bottom: 4%;
  }
  .newcomer-guide .card-tip{
    position: absolute;
    display: inline-block;
    right: 2vw;
    top: 2vw;
    border-radius: 20px;
    padding: 2px 8px;
    background: rgba(242, 242, 242, 0.5);
    color: #333;
    font-size: 12px;
  }
  .newcomer-guide .guide-title{
    margin-top: 6vw;
    color: #fff;
    font-size: 10vw;
    letter-spacing: 2px;
  }
  .newcomer-guide .guide-tip{
    position: relative;
    margin-top: 1vw;
    font-size: 17px;
    color: #fff;
  }
  .newcomer-guide .guide-tip::after{
    content: "";
    position: absolute;
    height: 2px;
    width: 50px;
    background: #f5f580;
    top: 6.5vw;
    left: 50%;
    transform: translateX(-50%);
  }
  .guide-list{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 4.5vw;
    padding: 0 5vw;
    box-sizing: border-box;
  }
  .guide-list .guide-item{
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: #fff;
    border-radius: 3px;
    padding: 2vw 4vw;
    font-size: 14px;
    color: #333;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  }
  .guide-item .iconfont{
    margin-bottom: 2px;
    font-size: 20px;
  }
  .guide-list .guide-item-icon .iconfont{
    color: #fff;
    font-size: 6vw;
  }
  /* list */
  .newcomer-box-list{
    background: #F36C69;
    background: linear-gradient(135deg, #F36C69, #F68043);
    min-height: calc(100vh - 50vw);
    padding-bottom: 1vw;
    overflow: hidden;
  }
  .newcomer-box-list >>> .hot-main{
    background: initial;
  }
  .newcomer-box-list >>> .zero-time-scroll{
    margin: -1px 0 5px;
    height: 56px;
    background: #fb3145;
    background: linear-gradient(to bottom, #fb3145, #F36C69 50%),
                linear-gradient(to right, #F36C69, #F68043);
    background-repeat: no-repeat;
    overflow: initial;
  }
  .newcomer-box-list >>> .zero-time-scroll .time-scorll-item{
    box-shadow: none;
  }
  .newcomer-box-list >>> .filter-radio{
    color: #333;
  }
  .newcomer-box-list >>> .filter-radio.active{
    border-color: transparent;
    color: #ff0000;
    background: #f5f580;
  }
  .newcomer-box-list >>> .cnt-list-item{border: none;}
  .newcomer-box-list >>> .segement-line{
    border-top-color: transparent;
  }
  .newcomer-box-list >>> .segement-line .line-tip{
    background: initial;
    color: #333;
  }
  .no-more-goods{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: #333;
    margin-top: 30%;
  }
  .no-more-img{
    width: 100px;
    height: 100px;
  }
  .no-more-img img{
    width: 100%;
    height: 100%;
    display: block;
  }
  @media screen and (max-width: 320px) {
    .guide-list .guide-item{
      padding: 1vw 3vw;
    }
  }
</style>
